import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const PROJECTS = [{
  title: 'Ethereal Garden Wedding',
  location: 'Beverly Hills, CA',
  image: 'https://cdn.magicpatterns.com/uploads/9ctXptddB3hLoxqjhtMs1z/pexels-pavel-danilyuk-8815274.jpg',
  category: 'Wedding'
}, {
  title: 'Modern Corporate Gala',
  location: 'Downtown Manhattan',
  image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069&auto=format&fit=crop',
  category: 'Corporate'
}, {
  title: 'Luxury Bridal Shower',
  location: 'The Hamptons',
  image: 'https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=2162&auto=format&fit=crop',
  category: 'Private'
}, {
  title: 'Midnight Soirée',
  location: 'Private Estate, Miami',
  image: 'https://cdn.magicpatterns.com/uploads/mr2X1sUaAGFTHwBbsAkqio/pexels-keynotez-12302950.jpg',
  category: 'Social'
}, {
  title: 'Golden Anniversary',
  location: 'Ritz Carlton',
  image: 'https://images.unsplash.com/photo-1510076857177-7470076d4098?q=80&w=2072&auto=format&fit=crop',
  category: 'Anniversary'
}, {
  title: 'Autumn Harvest Dinner',
  location: 'Napa Valley',
  image: 'https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=1974&auto=format&fit=crop',
  category: 'Private'
}];
export function RecentWorks() {
  return <section className="py-24 bg-white" data-id="element-92">
      <div className="mx-4 md:mx-[4.1rem]" data-id="element-93">
        <div className="max-w-[1440px] mx-auto px-6" data-id="element-94">
          {/* Section Header */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8" data-id="element-95">
            <div className="max-w-2xl" data-id="element-96">
              <span className="text-[12px] uppercase tracking-[0.3em] font-bold text-[#b22222] mb-4 block" data-id="element-97">
                Inspirations
              </span>
              <h2 className="font-serif text-4xl md:text-4xl lg:text-5xl text-gray-900 leading-tight" data-id="element-98">
                See some of <br data-id="element-99" />
                <span className="italic" data-id="element-100">our works</span>
              </h2>
            </div>
            <p className="text-gray-500 max-w-md text-base leading-relaxed pb-2 border-l-2 border-gray-100 pl-8" data-id="element-101">
              Discover our diverse style shoots, weddings and events and be
              inspired by creative concepts. Click through our inspirations and
              collect ideas for your own unforgettable event.
            </p>
          </motion.div>

          {/* Clean Grid Layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-102">
            {PROJECTS.map((project, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="group cursor-pointer" data-id="element-103">
                <div className="relative h-[200px] overflow-hidden mb-6 bg-gray-50" data-id="element-104">
                  <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-105" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-500" data-id="element-106" />

                  {/* Category Badge */}
                  <div className="absolute top-6 left-6 overflow-hidden" data-id="element-107">
                    <motion.span className="inline-block bg-white text-black px-4 py-1.5 text-[9px] font-bold uppercase tracking-widest translate-y-full group-hover:translate-y-0 transition-transform duration-500" data-id="element-108">
                      {project.category}
                    </motion.span>
                  </div>

                  {/* View Details Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-109">
                    <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center scale-75 group-hover:scale-100 transition-transform duration-500" data-id="element-110">
                      <span className="text-[10px] font-bold uppercase tracking-widest text-black" data-id="element-111">
                        View
                      </span>
                    </div>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-112">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-[#b22222] font-bold" data-id="element-113">
                    {project.location}
                  </p>
                  <h3 className="text-2xl font-serif text-gray-900 group-hover:text-[#b22222] transition-colors duration-300" data-id="element-114">
                    {project.title}
                  </h3>
                  <div className="w-0 h-[1px] bg-[#b22222] group-hover:w-full transition-all duration-500" data-id="element-115" />
                </div>
              </motion.div>)}
          </div>

          {/* CTA Section */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-32 text-center bg-gray-50 py-20 px-6 border border-gray-100" data-id="element-116">
            <h3 className="font-serif text-3xl md:text-4xl mb-6 text-gray-900" data-id="element-117">
              Like what you see?
            </h3>
            <p className="text-gray-500 mb-12 max-w-xl mx-auto text-lg" data-id="element-118">
              Let's discuss how we can bring this level of elegance and detail
              to your next event.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-119">
              <Link to="/contact" data-id="element-120">
                <button className="bg-[#b22222] text-white px-12 py-5 text-xs font-bold uppercase tracking-widest hover:bg-[#8b0000] transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-121">
                  Book a Consultation
                </button>
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}